import { BehaviorSubjectWrapper } from '@/rxdb/BehaviorSubjectWrapper';

const cache = {};
export const getCachedObservable = (key, observableFactoryFn) => {
    if (!cache[key]) {
        cache[key] = new BehaviorSubjectWrapper(observableFactoryFn());
    }
    return cache[key];
};
